import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67f89640"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order" }
const _hoisted_2 = { class: "order-left" }
const _hoisted_3 = { class: "order-status-title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "order-address" }, "收货地址及联系方式", -1))
const _hoisted_5 = { class: "order-address-info" }
const _hoisted_6 = { class: "order-right" }
const _hoisted_7 = { class: "order-title" }
const _hoisted_8 = { class: "order-title-left" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { style: {"color":"#F41C1C","margin-right":"0"} }
const _hoisted_13 = { class: "order-title-right" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "取消订单", -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "确认收货", -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "order-step" }
const _hoisted_19 = { class: "order-step-item" }
const _hoisted_20 = ["src"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "提交订单", -1))
const _hoisted_22 = { class: "order-data" }
const _hoisted_23 = { class: "order-data" }
const _hoisted_24 = { class: "order-step-line" }
const _hoisted_25 = {
  key: 0,
  class: "title"
}
const _hoisted_26 = {
  key: 1,
  src: "/static/order/ing.png"
}
const _hoisted_27 = {
  key: 2,
  src: "/static/order/end.png",
  class: "no-active"
}
const _hoisted_28 = { class: "order-step-item" }
const _hoisted_29 = ["src"]
const _hoisted_30 = {
  key: 0,
  class: "order-data"
}
const _hoisted_31 = {
  key: 1,
  class: "order-data"
}
const _hoisted_32 = { class: "order-step-line" }
const _hoisted_33 = {
  key: 0,
  class: "title"
}
const _hoisted_34 = {
  key: 1,
  src: "/static/order/ing.png"
}
const _hoisted_35 = {
  key: 2,
  src: "/static/order/notstart.png",
  class: "no-active"
}
const _hoisted_36 = {
  key: 3,
  src: "/static/order/end.png",
  class: "no-active"
}
const _hoisted_37 = { class: "order-step-item" }
const _hoisted_38 = ["src"]
const _hoisted_39 = {
  key: 0,
  class: "order-data"
}
const _hoisted_40 = {
  key: 1,
  class: "order-data"
}
const _hoisted_41 = { class: "order-step-line" }
const _hoisted_42 = {
  key: 0,
  class: "title"
}
const _hoisted_43 = {
  key: 1,
  src: "/static/order/ing.png"
}
const _hoisted_44 = {
  key: 2,
  src: "/static/order/notstart.png",
  class: "no-active"
}
const _hoisted_45 = {
  key: 3,
  src: "/static/order/end.png",
  class: "no-active"
}
const _hoisted_46 = { class: "order-step-item" }
const _hoisted_47 = ["src"]
const _hoisted_48 = {
  key: 0,
  class: "order-data"
}
const _hoisted_49 = {
  key: 1,
  class: "order-data"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CountDown = _resolveComponent("CountDown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.orderTypeMsg), 1),
      _hoisted_4,
      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.orderData.datas.address.contacts) + "，" + _toDisplayString(_ctx.showMobile(_ctx.orderData.datas.address.phonenumber)) + "，" + _toDisplayString(_ctx.orderData.datas.address.province) + " " + _toDisplayString(_ctx.orderData.datas.address.city) + " " + _toDisplayString(_ctx.orderData.datas.address.area) + " " + _toDisplayString(_ctx.orderData.datas.address.address), 1)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("span", null, "订单编号：" + _toDisplayString(_ctx.orderData.datas.oid), 1),
          (_ctx.orderData.datas.status != 2)
            ? (_openBlock(), _createElementBlock("span", _hoisted_9, "状态：" + _toDisplayString(_ctx.orderTypeMsgTips), 1))
            : _createCommentVNode("", true),
          (_ctx.orderData.datas.status == 1)
            ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                _createTextVNode("剩余时间： "),
                _createVNode(_component_CountDown, {
                  onCountdownEnded: _ctx.cancelOrder,
                  totaltime: 
                _ctx.getTime(
                  _ctx.orderData.datas.forRrestOf
                    ? _ctx.orderData.datas.forRrestOf
                    : '1665387853'
                )
              
                }, null, 8, ["onCountdownEnded", "totaltime"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.orderData.datas.send_status==2)
            ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                _createTextVNode("状态： 剩余"),
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.getEndTime(_ctx.orderData.datas.exp_time)), 1),
                _createTextVNode("天自动确认收货")
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_13, [
          (_ctx.imgList.data.create == 'create-2.png')
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "order-title-right-item",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cancelOrder && _ctx.cancelOrder(...args)))
              }, _hoisted_15))
            : _createCommentVNode("", true),
          (_ctx.imgList.data.send == 'send-2.png')
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "order-title-right-item",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.receiptOrder && _ctx.receiptOrder(...args)))
              }, _hoisted_17))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("img", {
            src: '/static/order/' + _ctx.imgList.data.create
          }, null, 8, _hoisted_20),
          _hoisted_21,
          _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.getsplittimestring(_ctx.orderData.datas.create_time)[0]), 1),
          _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.getsplittimestring(_ctx.orderData.datas.create_time)[1]), 1)
        ]),
        _createElementVNode("div", _hoisted_24, [
          (_ctx.imgList.data.pay == 'pay-0.png')
            ? (_openBlock(), _createElementBlock("p", _hoisted_25, "待支付"))
            : _createCommentVNode("", true),
          (_ctx.imgList.data.pay == 'pay-0.png')
            ? (_openBlock(), _createElementBlock("img", _hoisted_26))
            : (_openBlock(), _createElementBlock("img", _hoisted_27))
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("img", {
            src: '/static/order/' + _ctx.imgList.data.pay
          }, null, 8, _hoisted_29),
          _createElementVNode("p", {
            class: _normalizeClass(["title", { active: _ctx.imgList.data.pay == 'pay-0.png' }])
          }, " 支付成功 ", 2),
          (_ctx.imgList.data.pay != 'pay-0.png')
            ? (_openBlock(), _createElementBlock("p", _hoisted_30, _toDisplayString(_ctx.getsplittimestring(_ctx.orderData.datas.pay_time)[0]), 1))
            : _createCommentVNode("", true),
          (_ctx.imgList.data.pay != 'pay-0.png')
            ? (_openBlock(), _createElementBlock("p", _hoisted_31, _toDisplayString(_ctx.getsplittimestring(_ctx.orderData.datas.pay_time)[1]), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_32, [
          (
              _ctx.imgList.data.send == 'send-0.png' &&
              _ctx.imgList.data.pay == 'pay-2.png'
            )
            ? (_openBlock(), _createElementBlock("p", _hoisted_33, " 待发货 "))
            : _createCommentVNode("", true),
          (_ctx.imgList.data.pay == 'pay-2.png')
            ? (_openBlock(), _createElementBlock("img", _hoisted_34))
            : (_ctx.imgList.data.pay == 'pay-0.png')
              ? (_openBlock(), _createElementBlock("img", _hoisted_35))
              : (_ctx.imgList.data.pay == 'pay-1.png')
                ? (_openBlock(), _createElementBlock("img", _hoisted_36))
                : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("img", {
            src: '/static/order/' + _ctx.imgList.data.send
          }, null, 8, _hoisted_38),
          _createElementVNode("p", {
            class: _normalizeClass(["title", { active: _ctx.imgList.data.send == 'send-0.png' }])
          }, " 已发货 ", 2),
          (_ctx.imgList.data.send != 'send-0.png')
            ? (_openBlock(), _createElementBlock("p", _hoisted_39, _toDisplayString(_ctx.getsplittimestring(_ctx.orderData.datas.exp_time)[0]), 1))
            : _createCommentVNode("", true),
          (_ctx.imgList.data.send != 'send-0.png')
            ? (_openBlock(), _createElementBlock("p", _hoisted_40, _toDisplayString(_ctx.getsplittimestring(_ctx.orderData.datas.exp_time)[1]), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_41, [
          (
              _ctx.imgList.data.over == 'over-0.png' &&
              _ctx.imgList.data.send == 'send-2.png'
            )
            ? (_openBlock(), _createElementBlock("p", _hoisted_42, " 等待收货 "))
            : _createCommentVNode("", true),
          (_ctx.imgList.data.send == 'send-2.png')
            ? (_openBlock(), _createElementBlock("img", _hoisted_43))
            : (_ctx.imgList.data.send == 'send-0.png')
              ? (_openBlock(), _createElementBlock("img", _hoisted_44))
              : (_ctx.imgList.data.send == 'send-1.png')
                ? (_openBlock(), _createElementBlock("img", _hoisted_45))
                : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("img", {
            src: '/static/order/' + _ctx.imgList.data.over
          }, null, 8, _hoisted_47),
          _createElementVNode("p", {
            class: _normalizeClass(["title", { active: _ctx.imgList.data.over == 'over-0.png' }])
          }, " 已完成 ", 2),
          (_ctx.imgList.data.over != 'over-0.png')
            ? (_openBlock(), _createElementBlock("p", _hoisted_48, _toDisplayString(_ctx.getsplittimestring(_ctx.orderData.datas.update_time)[0]), 1))
            : _createCommentVNode("", true),
          (_ctx.imgList.data.over != 'over-0.png')
            ? (_openBlock(), _createElementBlock("p", _hoisted_49, _toDisplayString(_ctx.getsplittimestring(_ctx.orderData.datas.update_time)[1]), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}